import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AuthState } from "./auth.reducer";

export const selectAuthState = createFeatureSelector<AuthState>("auth");

export const isAuthenticated = createSelector(selectAuthState, (authState) => {
  return authState.isAuthenticated;
});

export const accessToken = createSelector(selectAuthState, (authState) => {
  return authState.accessToken;
});

export const activeUser = createSelector(selectAuthState, (authState) => {
  return authState.profile.preferred_username;
});

export const roles = createSelector(selectAuthState, (authState) => {
  return (authState.profile?.["roles"] as string[] | undefined) ?? [];
});
